import type { FunctionComponent } from 'react';

import { Button } from '@dr.pogodin/react-utils';

import IconPause from 'assets/images/icon-pause-circled-40px.svg';
import IconPlay from 'assets/images/icon-play-24px.svg';
import IconSkipToNext from 'assets/images/icon-skip-to-next.svg';

import iconButtonTheme from 'themes/Button/icon-without-background-40px.scss';

import S from './style.scss';

type PropsT = {
  canNext: boolean;
  canPrev: boolean;
  onNext: () => void;
  onPlayPause: () => void;
  onPrev: () => void;
  paused: boolean;
};

const Transport: FunctionComponent<PropsT> = ({
  canNext,
  canPrev,
  onNext,
  onPlayPause,
  onPrev,
  paused,
}) => (
  <div className={S.container}>
    <Button disabled={!canPrev} onClick={onPrev} theme={iconButtonTheme}>
      <IconSkipToNext
        className={canPrev ? undefined : S.disabled}
        fill="white"
        styleName="prev circled"
      />
    </Button>
    <Button onClick={onPlayPause} theme={iconButtonTheme}>
      {paused
        ? <IconPlay height={40} width={40} />
        : <IconPause />}
    </Button>
    <Button disabled={!canNext} onClick={onNext} theme={iconButtonTheme}>
      <IconSkipToNext
        className={canNext ? undefined : S.disabled}
        fill="white"
        styleName="circled"
      />
    </Button>
  </div>
);

export default Transport;
